import gql from "graphql-tag";

// List consignments along with their activities. This goes right through the
// system and into the Hallstein Labels system.
export const CONSIGNMENTS = gql`
  query consignments($warehouseId: String, $filter: ConsignmentsFilterInput, $pagination: PaginationInput, $sortOrders: [SortingInput]) {
    consignments(warehouseId: $warehouseId, filter: $filter, pagination: $pagination, sortOrders: $sortOrders) {
      entries {
        consignment {
          consignmentId
          extOrderId
          warehouseId
          service
          cost
          currency
          status
          deliveryInstructions
          packages {
            packageId
            trackingNr
          }
          sender {
            addressCity
            addressPostcode
            addressCountryCode
          }
          recipient {
            name
            attName
            addressAddressLine1
            addressAddressLine2
            addressCity
            addressPostcode
            addressStateProvince
            addressCountryCode
            type
          }
          updatedAt
          insertedAt
        }
        consignmentActivities {
          consignmentId
          trackingNrs
          status
          version
          updatedAt
          insertedAt
          activities {
            location
            occurredAtUtc
            trackingNr
            type
            message
          }
        }
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

export const MARK_CONSIGNMENT = gql`
  mutation markConsignment($data: MarkConsignmentInput!) {
    markConsignment(input: $data) {
      errors { key message }
    }
  }
`

export const REPORT_CONSIGNMENT = gql`
  mutation reportConsignment($data: ReportConsignmentInput!) {
    reportConsignment(input: $data) {
      errors { key message }
    }
  }
`